module.exports = __webpack_public_path__ + "static/img/camera-control-open.347f17f8.svg";